import { NavLink } from "react-router-dom";
import { Home, Flower2, Compass, Sparkles, Users, Sun } from "lucide-react";

const ITEMS = [
  { to: "/",          label: "Home",      Icon: Home,      testid: "nav-home" },
  { to: "/pratiche",  label: "Pratiche",  Icon: Flower2,   testid: "nav-pratiche" },
  { to: "/viaggi",    label: "Viaggi",    Icon: Compass,   testid: "nav-viaggi" },
  { to: "/ruota",     label: "Ruota",     Icon: Sparkles,  testid: "nav-ruota" },
  { to: "/community", label: "Community", Icon: Users,     testid: "nav-community" },
  { to: "/chi-siamo", label: "Profilo",   Icon: Sun,       testid: "nav-chi-siamo" },
];

export default function BottomNav() {
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md bg-[#f9f5ef]/95 backdrop-blur-md border-t border-[#ede7df] rounded-t-[28px] z-50 pb-safe"
      style={{ boxShadow: "0 -10px 30px -10px rgba(46,40,32,0.15)" }}
    >
      <ul className="flex items-stretch justify-around px-2 pt-2">
        {ITEMS.map(({ to, label, Icon, testid }) => (
          <li key={to} className="flex-1">
            <NavLink
              to={to}
              end={to === "/"}
              data-testid={testid}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-1 py-2 transition-colors ${
                  isActive ? "text-[#e07818]" : "text-[#7a6f65] hover:text-[#2e2820]"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <Icon strokeWidth={1.5} className="w-5 h-5" />
                  <span className="font-body text-[10px] font-light tracking-wide">{label}</span>
                  <span
                    className={`mt-0.5 h-[3px] w-6 rounded-full transition-all ${
                      isActive ? "bg-[#e07818] opacity-100" : "bg-transparent opacity-0"
                    }`}
                  />
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
